export const USER_TYPE = "Student"

export const BROWSER_STORAGE_KEYS = {
  hasFilledWarmLeadForm: "has_filled_warm_lead_form",
  tempDeviceId: "tempDeviceId",
  mercuryJwtBearer: "mercuryJwtBearer",
  mercuryLeadId: "mercuryLeadId"
}

export const COURSE_SLUGS = {
  pts: "pedagogy-teacher-standards",
  english: "speak-english-like-an-international-teacher"
}

export const CERTIFICATION_SLUGS = {
  mpd: "mandatory-professional-development-courses"
}

export const QUALIFICATION_SLUGS = {
  pgctl: "professional-graduate-certificate-in-teaching-learning",
  cit: "certificate-in-teaching",
  ait: "award-in-teaching"
}

export const LEARNING_MODES_SLUG = {
  SELF_PACED: "Self-paced",
  BLENDED: "Live Instructor-led",
  BLENDED_WITH_CERTIFICATE: "Live Instructor-led (UK Certified)"
}

export enum SERVICE_PREFIX {
  mercury = "mercury"
}
